/** A route country is an inventory boundary, not a ranking suggestion. */
export function normalizeInventoryCountry(value: string | null | undefined): string | undefined {
  const code = value?.trim().toUpperCase();
  return code === "UK" ? "GB" : code || undefined;
}

export function carsInCountry<T extends { countryCode?: string | null }>(
  cars: readonly T[],
  countryCode: string | null | undefined,
): T[] {
  const country = normalizeInventoryCountry(countryCode);
  return country
    ? cars.filter(car => normalizeInventoryCountry(car.countryCode) === country)
    : [...cars];
}